__turbopack_context__.v({
  "richTextEditor": "lxNSDW_richTextEditor",
  "richTextEditor__action": "lxNSDW_richTextEditor__action",
  "richTextEditor__body": "lxNSDW_richTextEditor__body",
  "richTextEditor__bodyDisabled": "lxNSDW_richTextEditor__bodyDisabled",
  "richTextEditor__content": "lxNSDW_richTextEditor__content",
  "richTextEditor__disabled": "lxNSDW_richTextEditor__disabled",
  "richTextEditor__footer": "lxNSDW_richTextEditor__footer",
  "richTextEditor__footerLeft": "lxNSDW_richTextEditor__footerLeft",
  "richTextEditor__footerRight": "lxNSDW_richTextEditor__footerRight",
  "richTextEditor__hasAction": "lxNSDW_richTextEditor__hasAction",
  "richTextEditor__linkDialogActions": "lxNSDW_richTextEditor__linkDialogActions",
  "richTextEditor__linkDialogDescription": "lxNSDW_richTextEditor__linkDialogDescription",
  "richTextEditor__linkDialogTitle": "lxNSDW_richTextEditor__linkDialogTitle",
  "richTextEditor__suggestionItem": "lxNSDW_richTextEditor__suggestionItem",
  "richTextEditor__suggestionItemSelected": "lxNSDW_richTextEditor__suggestionItemSelected",
  "richTextEditor__suggestions": "lxNSDW_richTextEditor__suggestions",
  "richTextEditor__suggestionsEmpty": "lxNSDW_richTextEditor__suggestionsEmpty",
  "richTextEditor__suggestionsHeader": "lxNSDW_richTextEditor__suggestionsHeader",
  "richTextEditor__suggestionsLabel": "lxNSDW_richTextEditor__suggestionsLabel",
  "richTextEditor__suggestionsList": "lxNSDW_richTextEditor__suggestionsList",
  "richTextEditor__suggestionsSearch": "lxNSDW_richTextEditor__suggestionsSearch",
  "richTextEditor__suggestionsSkeleton": "lxNSDW_richTextEditor__suggestionsSkeleton",
  "richTextEditor__toolbar": "lxNSDW_richTextEditor__toolbar",
  "richTextEditor__toolbarButton": "lxNSDW_richTextEditor__toolbarButton",
  "richTextEditor__toolbarSeparator": "lxNSDW_richTextEditor__toolbarSeparator",
});
